import { Injectable } from '@angular/core';
import { Lambda } from 'aws-sdk';
import { environment } from '../../../environments/environment';
import { ConfigService } from '../config/config.service';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class WallboardService {

  configurations = [];
  configurationsLife = [];
  siteList = [];
  siteListLife = [];
  queueList = [];
  queueListLife = [];
  allQueues = [];
  allQueuesLife = [];
  activeSiteName = '';
  activeSiteNameLife = '';
  activeQueueName = '';
  activeQueueNameLife = '';
  newSiteName = '';
  newSiteNameLife = '';
  activeQueueArn = '';
  activeQueueArnLife = '';
  announcements = [];
  announcementsLife = [];
  lob: string;
  lobLife: string;
  aggConfigs = {};
  aggConfigsLife = {};

  activeQueueConfig:any = {
    Announcements: '',
    QueueArn: '',
    QueueName: '',
    RotationDelay: '15',
    View: '',
    Thresholds: {
      red: {
        'ABN': 0,
        'Queue': 0,
        'Oldest': 0,
        'ASA': 0
      },
      yellow: {
        'ABN': 0,
        'Queue': 0,
        'Oldest': 0,
        'ASA': 0
      }
    }
  }

  activeQueueConfigLife:any = {
    Announcements: '',
    QueueArn: '',
    QueueName: '',
    RotationDelay: '15',
    View: '',
    Thresholds: {
      red: {
        'ServiceLevel': 0,
        'Queue': 0,
        'Oldest': 0,
        'ASA': 0
      },
      yellow: {
        'ServiceLevel': 0,
        'Queue': 0,
        'Oldest': 0,
        'ASA': 0
      }
    }
  }

  newAggregateConfig = {
    "AggregateView": true,
    "Announcements": "",
    "LeftPane": {
      "Enabled": true,
      "QueueList": [],
      "Thresholds": {
        "red": {
          "ABN": 0,
          "ASA": 0,
          "Queue": 0,
          "Oldest": 0
        },
        "yellow": {
          "ABN": 0,
          "ASA": 0,
          "Queue": 0,
          "Oldest": 0
        }
      },
      "Title": ""
    },
    "LOB": "",
    "QueueName": "",
    "RefreshInterval": 15,
    "RightPane": {
      "Enabled": true,
      "QueueList": [],
      "Thresholds": {
        "red": {
          "ABN": 0,
          "ASA": 0,
          "Queue": 0,
          "Oldest": 0
        },
        "yellow": {
          "ABN": 0,
          "ASA": 0,
          "Queue": 0,
          "Oldest": 0
        }
      },
      "Title": ""
    },
    "View": ""
  }

  newAggregateConfigLife = {
    "AggregateView": true,
    "Announcements": "",
    "CombinedPane": {
      "Enabled": true,
      "QueueList": [],
      "Thresholds": {
        "red": {
          "ServiceLevel": 0,
          "ASA": 0,
          "Queue": 0,
          "Oldest": 0
        },
        "yellow": {
          "ServiceLevel": 0,
          "ASA": 0,
          "Queue": 0,
          "Oldest": 0
        }
      },
      "Title": ""
    },
    "LOB": "",
    "QueueName": "",
    "RefreshInterval": 15,
    "View": ""
  }

  activeSiteConfig = {
    QueueArn: '',
    QueueName: '',
    View: '',
    RotationDelay: '',
    Thresholds: {
      yellow: {},
      red: {},
    },
    Announcements: '',
    RefreshInterval: ''
  };
  activeSiteConfigLife = {
    QueueArn: '',
    QueueName: '',
    View: '',
    RotationDelay: '',
    Thresholds: {
      yellow: {},
      red: {},
    },
    Announcements: '',
    RefreshInterval: ''
  };
  
  siteMetrics = [];
  siteMetricsLife = [];
  metricsTimeStamp = '';
  metricsTimeStampLife = '';
  queueDisplayIteration = 0;
  queueDisplayIterationLife = 0;
  showWallboard = false;
  showWallboardLife = false;
  private metricErrCount = 0;
  private metricErrCountLife =0;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private auth: AuthService
  ) { }

  async getConfigData(lob?: string) {
    let lambda = new Lambda();
    const funcName = environment.wallboardConfigLambdaName

    const params = {
      FunctionName: funcName,
      Payload: JSON.stringify({
        method: "QUERY",
        LOB: this.configService.activeLOB
      })
    }

    const promise = new Promise(async (resolve, reject) => {
      await this.auth.isAuthenticated()
      let lambdaResp: any;
      try {
        lambdaResp = await lambda.invoke(params).promise();
      } catch (err) {
        console.error('Error geting Wallboard Configs:', err);
        reject(err);
      }
      let configs = JSON.parse(lambdaResp['Payload']);
      this.siteList = [];
      this.configurations = configs;
      this.allQueues = [];
      for (let i = 0; i < this.configurations.length; i++) {
        let config = this.configurations[i];
        if (!this.siteList.includes(config.View)) {
          this.siteList.push(config.View);
        }
        const queue = {
          name: config.QueueName,
          arn: config.QueueArn
        }
        this.allQueues.push(queue);
      }
      resolve(configs);
    })

    return promise;

  };

  async setActiveSite(view: string) {
    return new Promise((resolve, reject) => {
      this.announcements = [];
      this.queueList = [];
      let aggView = false;
      for (let i = 0; i < this.configurations.length; i++) {
        let config = this.configurations[i];
        if (config.View === view) {
          if (config.Announcements) {
            this.announcements.push(config.Announcements);
          }
          if (config.AggregateView) {
            aggView = true;
          }
          this.queueList.push(config.QueueName);

          this.activeSiteConfig = config;
          this.activeSiteName = view;
        }
        if ((i + 1) === this.configurations.length && !this.activeSiteName) {
          reject('View not found');
        }
      }
      this.getSiteMetrics(view).then( data => {
        this.showWallboard = true;
        let resp = data;
        resp['AggregateView'] = aggView
        this.activeQueueName = this.queueList[0];
        this.setActiveQueue(this.queueList[0], this.activeSiteName)
        resolve(data);
      });

    })
  };

  setActiveQueue(queueName: string, view: string) {
    for (let i = 0; i < this.configurations.length; i++) {
      let config = this.configurations[i];
      if (config.QueueName === queueName && config.View === view) {
        this.activeQueueConfig = config;
      }
    }
    if(this.activeQueueConfig.Announcements == " "){
      this.activeQueueConfig.Announcements = "";
    }
  }

  async updateConfig(lob?: string) {
    let lambda = new Lambda();
    if(this.activeQueueConfig.Announcements == ""){
      this.activeQueueConfig.Announcements = " ";
    }

    const config = JSON.parse(JSON.stringify(this.activeQueueConfig));

    config.LOB = this.configService.activeLOB
    let aggView = config.AggregateView;

    if (!aggView) {
      aggView = false;
    }
    const payload = {
      method: 'POST',
      Config: config,
      AggregateView: aggView,
      View: this.activeQueueConfig.View,
      LOB: this.configService.activeLOB,
      QueueName: this.activeQueueConfig.QueueName,
      RotationDelay: this.activeQueueConfig.RotationDelay,
      Thresholds: this.activeQueueConfig.Thresholds,
    }
    if (this.activeQueueConfig.Announcements) {
      payload['Announcements'] = this.activeQueueConfig.Announcements
    }

    const funcName = environment.wallboardConfigLambdaName

    const params = {
      FunctionName: funcName,
      Payload: JSON.stringify(payload)
    }

    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          let response = JSON.parse(data['Payload']);
          this.getConfigData(lob).then(() => {
            // this.setActiveSite(this.activeSiteConfig.View);
            resolve(response);
            return response;
          });
        };
      });
    });

    return promise;
  };

  postConfig(lob?: string) {
    let lambda = new Lambda();

    const config = JSON.parse(JSON.stringify(this.activeQueueConfig));
    config.LOB = this.configService.activeLOB
    let aggView = config.AggregateView;

    if (aggView) {
      config.QueueName = config.View;
      this.activeQueueConfig.QueueName = null;
      
    } else {
      aggView = false;
    }

    //@**
    if(this.activeQueueConfig.Announcements == ""){
      this.activeQueueConfig.Announcements = " ";
    }
    if(config.Announcements == ""){
      config.Announcements = null;
    }

    const payload = {
      method: 'PUT',
      Config: config,
      AggregateView: aggView,
      LOB: this.configService.activeLOB,
      View: this.activeQueueConfig.View,
      QueueName: this.activeQueueConfig.QueueName,
      QueueArn: this.activeQueueConfig.QueueArn,
      RotationDelay: this.activeQueueConfig.RotationDelay,
      Thresholds: this.activeQueueConfig.Thresholds,
      Announcements: this.activeQueueConfig.Announcements
    }
    console.log(payload);

    const funcName = environment.wallboardConfigLambdaName

    const params = {
      FunctionName: funcName,
      Payload: JSON.stringify(payload)
    }

    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          let response = JSON.parse(data['Payload']);
          this.getConfigData(lob).then(() => {

            // this.setActiveSite(this.activeSiteConfig.View);
            resolve(response);
            return response;
          });
        };
      });
    });

    return promise;
  }

  // Get site metrics from lambda function
  async getSiteMetrics(siteName: string) {
    let lambda = new Lambda();

    const payload = {
      method: 'GET',
      siteName: siteName,
      LOB: this.configService.activeLOB
    }

    console.log("payload: ", payload);

    const params = {
      FunctionName: environment.wallboardMetricsLambdaName,
      Payload: JSON.stringify(payload)
    }

    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          this.siteMetrics = [];
          let metrics = [];
          let response = JSON.parse(data['Payload']);
          if (response.errorMessage) {
            console.error('Error getting metrics', response)
            if (!this.router.url.includes('config')) {
              this.metricErrCount++;
              if (this.metricErrCount > 5) {
                window.location.reload();
              }
            }
            return resolve(null)
          }
          this.metricErrCount = 0;
          this.metricsTimeStamp = response.TIME_STAMP;
          delete response.TIME_STAMP;
          for (let respkey in response) {
              let metricRaw = response[respkey];
              let metricResp = {
                QueueName: metricRaw.QueueName,
                metrics: []
              }
              delete metricRaw.QueueName;
              for (let key in metricRaw ) {
                let thisMetric = {
                  name: key,
                  value: metricRaw[key]
                }
                metricResp.metrics.push(thisMetric);
              }
              if (response.Left) {
                this.aggConfigs = response;
              }
              metrics.push(metricResp);
          }
          this.siteMetrics = metrics;
          console.log("siteMetrics: ", this.siteMetrics);
          resolve(metrics);
        };
      });
    });

    return promise;
  }

  // Get site metrics from lambda function new for Life
  async getSiteMetricsLife(siteName: string) {
    let lambda = new Lambda();

    const payload = {
      method: 'GET',
      siteName: siteName,
      LOB: this.configService.activeLOB
    }

    console.log("payload: ", payload);

    const params = {
      FunctionName: environment.lifeWallboardMetricsLambdaName,
      Payload: JSON.stringify(payload)
    }

    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          this.siteMetricsLife = [];
          let metricsLife = [];
          let response = JSON.parse(data['Payload']);
          if (response.errorMessage) {
            console.error('Error getting life metrics', response)
            if (!this.router.url.includes('config')) {
              this.metricErrCountLife++;
              if (this.metricErrCountLife > 5) {
                window.location.reload();
              }
            }
            return resolve(null)
          }
          this.metricErrCountLife = 0;
          this.metricsTimeStampLife = response.TIME_STAMP;
          delete response.TIME_STAMP;
          for (let respkey in response) {
              let metricRawLife = response[respkey];
              let metricRespLife = {
                QueueName: metricRawLife.QueueName,
                metricsLife: []
              }
              delete metricRawLife.QueueName;
              for (let key in metricRawLife ) {
                let thisMetricLife = {
                  name: key,
                  value: metricRawLife[key]
                }
                metricRespLife.metricsLife.push(thisMetricLife);
              }
              if (response.Left) {
                this.aggConfigsLife = response;
              }
              metricsLife.push(metricRespLife);
          }
          this.siteMetricsLife = metricsLife;
          console.log("lifesiteMetrics: ", this.siteMetricsLife);
          resolve(metricsLife);
        };
      });
    });

    return promise;
  }

  async setActiveSiteLife(view: string) {
    return new Promise((resolve, reject) => {
      this.announcementsLife = [];
      this.queueListLife = [];
      let aggView = false;
      for (let i = 0; i < this.configurationsLife.length; i++) {
        let config = this.configurationsLife[i];
        if (config.View === view) {
          if (config.Announcements) {
            this.announcementsLife.push(config.Announcements);
          }
          if (config.AggregateView) {
            aggView = true;
          }
          this.queueListLife.push(config.QueueName);

          this.activeSiteConfigLife = config;
          this.activeSiteNameLife = view;
        }
        if ((i + 1) === this.configurationsLife.length && !this.activeSiteNameLife) {
          reject('View not found');
        }
      }
      this.getSiteMetricsLife(view).then( data => {
        this.showWallboardLife = true;
        let resp = data;
        resp['AggregateView'] = aggView
        this.activeQueueNameLife = this.queueListLife[0];
        this.setActiveQueueLife(this.queueListLife[0], this.activeSiteNameLife)
        resolve(data);
      });

    })
  };

  async setActiveQueueLife(queueName: string, view: string) {
    for (let i = 0; i < this.configurationsLife.length; i++) {
      let config = this.configurationsLife[i];
      if (config.QueueName === queueName && config.View === view) {
        this.activeQueueConfigLife = config;
      }
    }
    if(this.activeQueueConfigLife.Announcements == " "){
      this.activeQueueConfigLife.Announcements = "";
    }
  }

  async getConfigDataLife(lob?: string) {
    let lambda = new Lambda();
    const funcName = environment.lifeWallboardConfigLambdaName

    const params = {
      FunctionName: funcName,
      Payload: JSON.stringify({
        method: "QUERY",
        // siteName: this.configService.selectedQueueName,
        LOB: this.configService.activeLOBLife
      })
    }

    const promise = new Promise(async (resolve, reject) => {
      await this.auth.isAuthenticated()
      let lambdaResp: any;
      try {
        lambdaResp = await lambda.invoke(params).promise();
      } catch (err) {
        console.error('Error geting Life Wallboard Configs:', err);
        reject(err);
      }
      let configs = JSON.parse(lambdaResp['Payload']);
      this.siteListLife = [];
      this.configurationsLife = configs;
      this.allQueuesLife = [];
      for (let i = 0; i < this.configurationsLife.length; i++) {
        let config = this.configurationsLife[i];
        if (!this.siteListLife.includes(config.View)) {
          this.siteListLife.push(config.View);
        }
        const queue = {
          name: config.QueueName,
          arn: config.QueueArn
        }
        this.allQueuesLife.push(queue);
      }
      resolve(configs);
    })

    return promise;

  };

  async updateConfigLife(lob?: string) {
    let lambda = new Lambda();
    if(this.activeQueueConfigLife.Announcements == ""){
      this.activeQueueConfigLife.Announcements = " ";
    }

    const config = JSON.parse(JSON.stringify(this.activeQueueConfigLife));

    config.LOB = this.configService.activeLOBLife
    let aggView = config.AggregateView;

    if (!aggView) {
      aggView = false;
    }
    const payload = {
      // method: 'POST',
      // Config: config,
      // AggregateView: aggView,
      // View: this.activeQueueConfigLife.View,
      // LOB: this.configService.activeLOBLife,
      // QueueName: this.activeQueueConfigLife.QueueName,
      // Announcements: this.activeQueueConfigLife.Announcements,
      // // RotationDelay: this.activeQueueConfigLife.RotationDelay,
      // // Thresholds: this.activeQueueConfigLife.Thresholds,
      // RefreshInterval: this.activeQueueConfigLife.RefreshInterval

      method: 'POST',
      Config: config,
      AggregateView: aggView,
      View: this.activeQueueConfigLife.View,
      LOB: this.configService.activeLOBLife,
      QueueName: this.activeQueueConfigLife.QueueName,
      RotationDelay: this.activeQueueConfigLife.RotationDelay,
      Thresholds: this.activeQueueConfigLife.Thresholds,
    }
    if (this.activeQueueConfigLife.Announcements) {
      payload['Announcements'] = this.activeQueueConfigLife.Announcements
    }

    const funcName = environment.lifeWallboardConfigLambdaName

    const params = {
      FunctionName: funcName,
      Payload: JSON.stringify(payload)
    }

    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          let response = JSON.parse(data['Payload']);
          this.getConfigDataLife(lob).then(() => {
            // this.setActiveSite(this.activeSiteConfig.View);
            resolve(response);
            return response;
          });
        };
      });
    });

    return promise;
  };

  async postConfigLife(lob?: string) {
    let lambda = new Lambda();

    const config = JSON.parse(JSON.stringify(this.activeQueueConfigLife));
    config.LOB = this.configService.activeLOBLife
    let aggView = config.AggregateView;

    if (aggView) {
      config.QueueName = config.View;
      this.activeQueueConfigLife.QueueName = null;
      
    } else {
      aggView = false;
    }

    //@**
    if(this.activeQueueConfigLife.Announcements == ""){
      this.activeQueueConfigLife.Announcements = " ";
    }
    if(config.Announcements == ""){
      config.Announcements = null;
    }

    const payload = {
      // method: 'POST',
      // Config: config,
      // AggregateView: aggView,
      // LOB: this.configService.activeLOBLife,
      // View: this.activeQueueConfigLife.View,
      // QueueName: this.activeQueueConfigLife.QueueName,
      // // QueueArn: this.activeQueueConfigLife.QueueArn,
      // // RotationDelay: this.activeQueueConfigLife.RotationDelay,
      // Thresholds: this.activeQueueConfigLife.Thresholds,
      // Announcements: this.activeQueueConfigLife.Announcements,
      // RefreshInterval: this.activeQueueConfigLife.RefreshInterval

      method: 'POST',
      Config: config,
      AggregateView: aggView,
      LOB: this.configService.activeLOBLife,
      View: this.activeQueueConfigLife.View,
      QueueName: this.activeQueueConfigLife.QueueName,
      QueueArn: this.activeQueueConfigLife.QueueArn,
      RotationDelay: this.activeQueueConfigLife.RotationDelay,
      Thresholds: this.activeQueueConfigLife.Thresholds,
      Announcements: this.activeQueueConfigLife.Announcements
    }
    console.log(payload);

    const funcName = environment.lifeWallboardConfigLambdaName

    const params = {
      FunctionName: funcName,
      Payload: JSON.stringify(payload)
    }

    const promise = new Promise((resolve, reject) => {
      lambda.invoke(params, (err: any, data: any) => {
        if (err) {
          console.error(err);
          reject(err);
        } else {
          let response = JSON.parse(data['Payload']);
          this.getConfigDataLife(lob).then(() => {

            // this.setActiveSite(this.activeSiteConfig.View);
            resolve(response);
            return response;
          });
        };
      });
    });

    return promise;
  }

}
